<template>
  <div class="ColumnHeader">
    <h3 class="ColumnHeader-title">
      {{ column.title }}
    </h3>

    <div v-if="column.highlight || column.tag" class="ColumnHeader-tags">
      <Tag
        v-if="column.highlight"
        type="neutral"
        variant="outlined"
        size="xs"
      >
        {{ column.highlight }}
      </Tag>

      <Tag
        v-if="column.tag"
        v-bind="tagProps"
        size="xs"
      >
        {{ column.tag }}
      </Tag>
    </div>
  </div>
</template>

<script setup lang="ts">
import Tag from '@cvo/ui/components/atoms/Tag/Tag.vue';
import type { TagProps } from '@cvo/ui/components/atoms/Tag/Tag.model';
import type { ComparisonColumn } from './BasePlanComparisonTable.model';

defineProps<{
  column: ComparisonColumn;
  /** State pill styling, resolved by the table from {@link ComparisonColumn.state}. */
  tagProps: Pick<TagProps, 'type' | 'variant'>;
}>();
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .ColumnHeader {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: vars.$dimensions-d-2;

    &-title {
      color: vars.$organisms-table-comparison-table-content-title-color;
      @include text.heading-responsive(h5, h6, h6);
    }

    &-tags {
      display: flex;
      gap: vars.$dimensions-d-2;
      align-items: flex-start;
    }
  }
}
</style>
